import React from "react";
import { Container } from "react-bootstrap";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const ImagenCoorporativa = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Imagen Coorporativa</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div className="Text_Buttons_Radio_buttons">
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Del Proceso</th>
                <th>Descripción</th>
                <th>Documentación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p>
                    <b>Fondos Institucionales</b>
                  </p>
                </td>
                <td>
                  <p>
                    Tener fondos institucionales para las sesiones de Zoom 
                    garantiza la continuidad profesional, la imagen corporativa, 
                    el control administrativo y la trazabilidad de reuniones clave, 
                    fortaleciendo la eficiencia y seguridad de las comunicaciones 
                    empresariales y refuerza la identidad de la empresa y genera 
                    confianza en clientes, socios y empleados.
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/zip/wallpapers-netjer.zip`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Fondos Institucionales
                  </a>{" "}
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <p>
                    <b>Presentaciones coorporativas</b>
                  </p>
                </td>
                <td>
                  <p>
                  Contar con formatos oficiales estandariza la comunicación, 
                  fortalece la imagen corporativa y asegura que los mensajes 
                  transmitidos sean claros, consistentes y alineados a los valores de la empresa.
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/pptx/netjer-networks-press-oscura.pptx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Presentación Oscura
                  </a>{" "}
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/pptx/netjer-networks-press-clara.pptx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Presentación Clara
                  </a>{" "}
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <p>
                    <b>Iconografía</b>
                  </p>
                </td>
                <td>
                  <p>
                  Asegura uniformidad visual, fortalece el reconocimiento 
                  de la marca y mejora la comunicación visual en las presentaciones.
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/zip/iconografia-oscura.zip`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Iconografía Oscura
                  </a>{" "}
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/zip/iconografia-anaranjada.zip`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Iconografía Anaranjada
                  </a>{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default ImagenCoorporativa;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
